export default {
    FETCH_TRANSFERS_FOR_LIST: 'fetchTransfersForList',
    SAVE_LISTS: 'saveLists'
}
